export default function techinicalteams(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            // GUARD: muitos modulos da app dispatcham `type: 'ADD_CURRENT'`
            // sem namespace (organizations, addresses, articles, etc.).
            // Sem este check, qualquer addCurrent de outro modulo sobrescreve
            // techinicalteam=undefined, quebrando paginas que dependem do state.
            if (action.techinicalteam === undefined) return state;
            return {
                ...state,
                techinicalteam: action.techinicalteam,
            }
        default:
            return state;
    }
}
